ixModuleRouting("impactx.suppliercatalogupload", {
    "/suppliercatalogupload": {
        template: "<ixa-supplier-catalog-upload></ixa-supplier-catalog-upload>",
        templateUrl:
            "modules/suppliercatalogupload/templates/catalogupload.tmpl.html",
        controller: "CatalogUploadCtrl as catalogUploadCtrl",
        process: "SupplierCatalogUpload",
        workspace: "content",
    },
    "/suppliercatalogupload/:replaceCatId": {
        template: "<ixa-supplier-catalog-upload></ixa-supplier-catalog-upload>",
        templateUrl:
            "modules/suppliercatalogupload/templates/catalogupload.tmpl.html",
        controller: "CatalogUploadCtrl as catalogUploadCtrl",
        process: "SupplierCatalogUpload",
        workspace: "content",
    },
});
